<app-header title="self-serve.payYourTeam.addYourCompanyLogo"></app-header>
<p class="text-color-secondary-font margin-bottom-4">{{ 'self-serve.payYourTeam.companyLogoDetails' | translate }}</p>

<app-company-logo-uploader></app-company-logo-uploader>
<ui-banner class="margin-bottom-6" variant="bulb"> {{ 'settings.company-logo.tipMessage' | translate }} </ui-banner>

<app-header title="self-serve.payYourTeam.addYourOffice"></app-header>
<form
    #form="ngForm"
    [appFormPersistence]="!stepStatus && !isLoading ? 'companyProfileForm' : ''"
    [fieldsToExclude]="['address']"
    [class.loading]="isLoading"
    (ngSubmit)="onSubmit()"
>
    <mat-form-field class="w-100">
        <mat-label>{{ 'company.office-form.nameLabel' | translate }}</mat-label>
        <input
            matInput
            type="text"
            required
            name="name"
            #name="ngModel"
            [(ngModel)]="office.name"
            placeholder="{{ 'company.office-form.canadianHeadquarters' | translate }}"
        />
        <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
    </mat-form-field>

    <app-address [showAutocomplete]="true" name="address" [(ngModel)]="office"></app-address>

    <div class="flex buttons justify-end">
        <ui-button *ngIf="showIWillDoItLater" type="outline" (click)="next()">{{
            'self-serve.iWillDoItLater' | translate
        }}</ui-button>
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{ 'save' | translate }}</ui-button>
    </div>
</form>
